<template>
  <div class="msearch">
    <div class="msebanner">
      <p class="msetitle">探索您需要的内容!</p>
      <el-input
        v-model="mseinput"
        placeholder=""
        style="border-radius: 1.07vw"
        suffix-icon="el-icon-search"
      ></el-input>
    </div>
    <div class="msecon">
      <div class="msecsingle" v-for="(i, j) in list" :key="j">
        <div class="singletitle">{{ i.title }}</div>
        <div class="singlecon">{{ i.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mseinput: "",
      list: [
        {
          title: "兖州南站完成主体结构封顶",
          content:
            "12月25日，鲁南高铁站房项目最后一座站房——兖州南站完成主体结构封顶，至此，全线6座高铁站房全部封顶，实现全线站房主体结构的完美收官。 兖州南站建筑面积约27000㎡，站台规模为21111111111111",
        },
        {
          title: "兖州南站完成主体结构封顶",
          content:
            "12月25日，鲁南高铁站房项目最后一座站房——兖州南站完成主体结构封顶，至此，全线6座高铁站房全部封顶，实现全线站房主体结构的完美收官。 兖州南站建筑面积约27000㎡，站台规模为21111111111111",
        },
        {
          title: "兖州南站完成主体结构封顶",
          content:
            "12月25日，鲁南高铁站房项目最后一座站房——兖州南站完成主体结构封顶，至此，全线6座高铁站房全部封顶，实现全线站房主体结构的完美收官。 兖州南站建筑面积约27000㎡，站台规模为21111111111111",
        },
        {
          title: "兖州南站完成主体结构封顶",
          content:
            "12月25日，鲁南高铁站房项目最后一座站房——兖州南站完成主体结构封顶，至此，全线6座高铁站房全部封顶，实现全线站房主体结构的完美收官。 兖州南站建筑面积约27000㎡，站台规模为21111111111111",
        },
        {
          title: "兖州南站完成主体结构封顶",
          content:
            "12月25日，鲁南高铁站房项目最后一座站房——兖州南站完成主体结构封顶，至此，全线6座高铁站房全部封顶，实现全线站房主体结构的完美收官。 兖州南站建筑面积约27000㎡，站台规模为21111111111111",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.msearch {
  .msecon {
    .msecsingle {
      .singlecon {
        color: rgba(6, 25, 45, 0.68);
        font-size: 3.2vw;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        /* 显示的最大行数 */
        overflow: hidden;
        height: 12vw;
      }
      .singletitle {
        font-size: 4vw;
        font-weight: 600;
        color: #06192d;
        margin-bottom: 2.67vw;
      }
      width: 100%;
      height: 26.13vw;
      border-bottom: 1px solid rgba(6, 25, 45, 0.1);
      padding-bottom: 4vw;
      margin-bottom: 4vw;
    }
    width: 100%;
    padding: 4vw;
  }
  .msebanner {
    .msetitle {
      font-size: 4.8vw;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 4vw;
    }
    width: 100%;
    height: 42.67vw;
    background: url("../../assets/image/msebanner.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 7.47vw 9.87vw 16vw 9.87vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  width: 100%;
  height: 100%;
}
::v-deep.el-icon-search:before {
  color: #1961ac !important;
  font-size: 4.53vw;
}
</style>
